import { getLinks } from "@cinch-nx/data-storyblok";
import { storeStaticPaths } from "./data/landing-store-feature.data";
export const getStaticPathsGenerator = (slug)=>async ()=>{
        // Get the paths we want to pre-render based on data
        try {
            const links = await getLinks(slug);
            const paths = storeStaticPaths({
                links
            });
            return {
                paths,
                fallback: "blocking"
            };
        } catch  {
            return {
                paths: [],
                fallback: "blocking"
            };
        }
    };
